import styled from "styled-components";

import {
  flexCenter,
  flexColumn,
  rem,
} from "@styles/Utilities.styled";


export const StyledEditPartnerModalContent = styled.div`
  ${flexColumn}
  
  .mantine-Tabs-root {
    margin-top: ${rem(-10)};
  }

  .mantine-Tabs-list {
    border-bottom: 1px solid var(--clr-gray-175);
    margin-bottom: 1.5rem;
  }

  .mantine-Tabs-tab {
    padding: 1rem 1.5rem;
    font-weight: 500;
    color: var(--clr-gray-400);
    transition: all 0.2s ease;

    &[data-active] {
      color: var(--clr-primary-400);
      border-bottom: 2px solid var(--clr-primary-400);
    }

    &:hover:not([data-active]) {
      background-color: var(--clr-gray-100);
      border-color: transparent;
    }
  }

  .mantine-Tabs-panel {
    padding: 0.5rem 0;
  }

  .dropzone-container {
    ${flexCenter}
    flex-direction: column;
    height: ${rem(120)};
    padding: 1.5rem;
    background-color: var(--clr-gray-100);
    border: 2px dashed var(--clr-gray-175);
    border-radius: var(--border-radius-2);
    cursor: pointer;
    transition: all 0.2s ease;
    text-align: center;

    &:hover {
      border-color: var(--clr-primary-400);
      background-color: var(--clr-white);
    }

    p {
      margin-top: 0.5rem;
      font-size: ${rem(14)};
      color: var(--clr-gray-400);
    }
  }

  .media-grid {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(${rem(80)}, 1fr));
    gap: 1rem;
    margin-top: 1rem;
  }

  .gallery-item {
    position: relative;
    width: ${rem(80)};
    height: ${rem(80)};

    .remove-overlay {
      position: absolute;
      top: 0;
      right: 0;
      background: rgba(255, 255, 255, 0.8);
      border-radius: 0 0 0 8px;
      cursor: pointer;
      display: none;
    }

    &:hover .remove-overlay {
      display: flex;
    }
  }

  .brand-preview {
    display: flex;
    align-items: center;
    gap: 1rem;
    padding: 1rem;
    background-color: var(--clr-gray-100);
    border-radius: var(--border-radius-2);
    margin-bottom: 1.5rem;

    .color-box {
      width: ${rem(48)};
      height: ${rem(48)};
      border-radius: 8px;
      border: 2px solid var(--clr-white);
      box-shadow: 0 2px 4px rgba(0,0,0,0.05);
    }

    .preview-text {
      flex: 1;
      
      .preview-title {
        font-weight: 600;
        font-size: ${rem(14)};
        color: var(--clr-primary-700);
      }
      
      .preview-subtitle {
        font-size: ${rem(12)};
        color: var(--clr-gray-400);
      }
    }
  }

  /* Form field consistency */
  .mantine-TextInput-label,
  .mantine-Select-label,
  .mantine-Textarea-label,
  .mantine-TagsInput-label,
  .mantine-NumberInput-label,
  .mantine-Radio-label {
    font-weight: 500;
    margin-bottom: 0.5rem;
    font-size: ${rem(14)};
    color: var(--clr-primary-700);
  }

  .mantine-TextInput-input,
  .mantine-Select-input,
  .mantine-Textarea-input,
  .mantine-TagsInput-input,
  .mantine-NumberInput-input {
    border-color: var(--clr-gray-175);
    
    &:focus {
      border-color: var(--clr-primary-400);
    }
  }
`;
